import { ReactNode, useState } from 'react';

import { cx } from '@libs/classnames';
import { HorizontalScroll } from '@ui/components/HorizontalScroll';
import { InlineInput } from '@ui/components/InlineInput';
import { Table, TableCell, TableRow } from '@ui/components/Table';
import { CameraIcon } from '@ui/icons/CameraIcon';

import { MemberAux } from '@features/club/typings';
import { ParticipantListItem } from '@features/club/ui/ClubParticipantsForm/components/List/ListItem';
import { MemberDto, ParticipantDto, RcfAttributes } from '@features/shared/api/typings';

import styles from './List.module.css';

export type Props = {
  className?: string;
  participants?: ParticipantDto[] | MemberDto[];
  groupTitle?: string;
  onGroupTitleChange?: (newGroupTitle: string | null) => void;
  renderParticipantActions?: (participant: ParticipantDto | MemberDto) => ReactNode;
  highlightedUserId?: string;
  onMemberGroupNameChange?: (userId: string, newGroupName: string | null) => void;
  memberGroupNameOptions?: string[];
  isRcf: boolean;
  onRcfAttributesChange?: (newValue: RcfAttributes) => void;
  onCamerasChange?: (userId: string, aux: MemberAux | null) => void;
};

export function List({
  className,
  participants,
  renderParticipantActions,
  highlightedUserId,
  onMemberGroupNameChange,
  groupTitle,
  memberGroupNameOptions,
  onGroupTitleChange,
  isRcf,
  onRcfAttributesChange,
  onCamerasChange,
}: Props) {
  const [openRcfModalUserId, setOpenRcfModalUserId] = useState<string | null>(null);
  return (
    <HorizontalScroll>
      <Table className={cx(className, styles.participantsList)}>
        <TableRow header>
          <TableCell className={styles.nameColumn}>Имя</TableCell>
          <TableCell className={styles.mailColumn} leftGap>
            Email
          </TableCell>
          <TableCell className={styles.groupColumn} leftGap>
            <InlineInput value={groupTitle || 'Группа'} onChange={onGroupTitleChange} />
          </TableCell>
          {isRcf && <TableCell>{/* ФШР ID */}</TableCell>}
          {onCamerasChange && (
            <TableCell slim leftGap className={styles.camerasColumn}>
              <span title="Камеры на видеоконтроле">
                <CameraIcon />
              </span>
            </TableCell>
          )}
          <TableCell>{/* renderActions */}</TableCell>
        </TableRow>

        {participants?.map((p) => (
          <ParticipantListItem
            key={p.userId}
            participant={p}
            renderActions={renderParticipantActions}
            highlighted={p.userId === highlightedUserId}
            onMemberGroupNameChange={onMemberGroupNameChange}
            memberGroupNameOptions={memberGroupNameOptions}
            isRcf={isRcf}
            isRcfModalOpen={openRcfModalUserId === p.userId}
            setRcfModalOpen={setOpenRcfModalUserId}
            onRcfAttributesChange={onRcfAttributesChange}
            onCamerasChange={onCamerasChange}
          />
        ))}
      </Table>
      {(!participants || !participants.length) && (
        <div className={styles.placeholder}>Нет участников</div>
      )}
    </HorizontalScroll>
  );
}
